import { render, staticRenderFns } from "./AdminTextList.vue?vue&type=template&id=46071e34"
import script from "./AdminTextList.vue?vue&type=script&lang=js"
export * from "./AdminTextList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports